<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ dirty }">
      <table class="table table table-striped mobile-table">
        <thead>
          <tr>
            <td colspan="6">
              <v-toolbar color="secondary" pa-0>
                <v-toolbar-title class="white--text">
                  From Application
                </v-toolbar-title>
              </v-toolbar>
            </td>
          </tr>
          <tr>
            <th scope="col"></th>
            <th class="col-lg-1">Quantity</th>
            <th scope="col">Equipment</th>

            <th>Cost (ex)</th>
            <th scope="col">Comment</th>
            <th align="right">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(extension, index) in filteredFromIPOrder"
            :key="extension.hardwareID"
          >
            <td align="center">
              <div v-show="extension.hardwareID">
                <v-icon color="green" title="Saved">check_circle</v-icon>
              </div>
            </td>
            <td>
              <vonex-text
                v-model="extension.quantity"
                class="text-right form-control custom-td"
                :name="'quantity' + index"
                :readonly="true"
                :rule="'min_value: 1'"
                :options="fieldConditions"
                hide-details
                @change="updateRow(index, extension)"
              />
            </td>
            <td>
              <vonex-select
                v-if="handsets && handsets.length > 1 && !extension.isNbn"
                v-model="extension.handsetID"
                class="form-control custom-td"
                :name="'handsetID' + index"
                :rule="`required`"
                :disabled="true"
                :items="allHandsets"
                :item-text="setText"
                item-value="handsetID"
                hide-details
                @change="onChange(extension)"
              ></vonex-select>
              <vonex-text
                v-else
                v-model="extension.handsetID"
                class="text-right form-control custom-td"
                :name="'handsetID' + index"
                :disabled="true"
                :rule="'required'"
                :options="fieldConditions"
                hide-details
              />
            </td>
            <td class="currency">{{ extension.cost | currency }}</td>
            <td>{{ extension.comment }}</td>
            <td class="currency">{{ extension.lineTotal | currency }}</td>
          </tr>
        </tbody>
        <thead>
          <tr>
            <td colspan="6">
              <v-toolbar color="secondary" pa-0>
                <v-toolbar-title class="white--text">
                  Additional Hardware
                  <v-btn
                    v-show="
                      (isGrenke && allFlags.SOG635) ||
                      !isGrenke ||
                      bundledHardware
                    "
                    round
                    small
                    color="primary"
                    name="addrow"
                    @click="addRow"
                  >
                    Add Row
                  </v-btn>
                </v-toolbar-title>
                <div
                  v-show="nonQBRGrenke && allFlags.SOG3160"
                  class="right-div elevation-2 pa-2 pl-4"
                >
                  <p class="display-inline grey--text text--darken-4 mb-0">
                    Finance Hardware?
                  </p>
                  <v-radio-group
                    v-model="financedHardware"
                    row
                    class="display-inline ml-3"
                    hide-details
                  >
                    <v-radio
                      name="financed"
                      :value="true"
                      label="Yes"
                      color="grey darken-4"
                    ></v-radio>
                    <v-radio
                      name="notFinanced"
                      :value="false"
                      label="No"
                      color="grey darken-4"
                    ></v-radio>
                  </v-radio-group>
                </div>
              </v-toolbar>
            </td>
          </tr>
          <tr>
            <th scope="col"></th>
            <th class="col-lg-1">Quantity</th>
            <th scope="col">Equipment</th>

            <th>Cost (ex)</th>
            <th scope="col">Comment</th>
            <th align="right">Amount</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(extension, index) in filteredAdditionalHardware"
            :key="index"
          >
            <td>
              <v-layout row>
                <v-icon
                  v-show="extension.hardwareID && extension.hardwareOrderID"
                  color="green"
                  title="Saved"
                >
                  check_circle
                </v-icon>
                <v-icon
                  v-show="!extension.bundleId"
                  title="Delete"
                  @click="removeRow(rows.indexOf(extension))"
                >
                  delete
                </v-icon>
              </v-layout>
            </td>
            <td>
              <!-- :class="{'text-right': true,'text-right danger': errors.has('quantity' + index),}" -->
              <vonex-text
                v-model="extension.quantity"
                class="text-right form-control custom-td"
                :name="'quantity' + index"
                :readonly="isQuantityLocked(extension)"
                :rule="quantityRule"
                :error="showQuantityError(extension)"
                :options="fieldConditions"
                hide-details
                @change="updateRow(index, extension)"
              />
              <!-- <ValidationProvider name="hardware quantity" rules="min_value: 1" v-slot="{ errors }">
            <input
              v-model="extension.quantity"
              class="text-right form-control"
              :name="'quantity' + index"
              @keyup="updateRow(index)"
              :readonly="extension.bundleId !== 0"
            />
              </ValidationProvider>-->
            </td>
            <td>
              <!-- :class="{ '': true, danger: errors.has('handsetID' + index) }" -->
              <!-- <vonex-autocomplete
                :ref="'handsetID' + index"
                v-model="extension.handsetID"
                :options="fieldConditions"
                hide-details
                :items="validHandsets"
                search-input.sync="model"
                :update:error.sync="addNewContent"
                item-text="model"
                item-value="handsetID"
                auto-select-first
                class="form-control custom-td"
                flat
                :name="'handsetID' + index"
                box
                :readonly="extension.bundleId !== 0"
                :rule="`required`"
                @input="onChange(extension)"
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.model }} ({{
                    data.item.manufacturer.description
                  }})
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="`${data.item.model}`"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.manufacturer.description"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </vonex-autocomplete> -->
              <vonex-autocomplete
                v-model="extension.handsetID"
                :items="validHandsets"
                search-input.sync="model"
                :update:error.sync="addNewContent"
                item-text="model"
                item-value="handsetID"
                auto-select-first
                class="form-control"
                flat
                :name="'handsetID' + index"
                :rule="`required|planId`"
                box
                :readonly="extension.bundleId !== 0"
                @change="onChange(extension)"
              >
                <template slot="selection" slot-scope="data">
                  {{ data.item.model }} ({{
                    data.item.manufacturer.description
                  }})
                </template>
                <template slot="item" slot-scope="data">
                  <v-list-tile-content>
                    <v-list-tile-title
                      v-html="`${data.item.model}`"
                    ></v-list-tile-title>
                    <v-list-tile-sub-title
                      v-html="data.item.manufacturer.description"
                    ></v-list-tile-sub-title>
                  </v-list-tile-content>
                </template>
              </vonex-autocomplete>
            </td>
            <td v-if="isFTC(extension.handsetID) || isCostEditable(extension)">
              <vonex-text
                ref="cost"
                v-model="extension.cost"
                :options="fieldConditions"
                name="cost"
                hide-details
                prefix="$"
                :readonly="!isCostEditable(extension)"
                class="custom-td"
                @change="updateRow(index, extension)"
              ></vonex-text>
              <!-- <v-text-field
              v-model="extension.cost"
              prefix="$"
              @change="updateRow(index)"
              readonly
              ></v-text-field>-->
            </td>
            <td v-else class="currency" :style="align">
              {{ extension.cost | currency }}
            </td>
            <td>
              <!-- :class="{ '': true, danger: errors.has('comment' + index) }" -->
              <vonex-text
                :ref="'comment' + index"
                v-model="extension.comment"
                :options="fieldConditions"
                hide-details
                class="form-control custom-td"
                :name="'comment' + index"
                :readonly="extension.bundleId !== 0"
              ></vonex-text>
              <!-- <v-text-field
              v-model="extension.comment"
              class="form-control"
              :name="'comment' + index"
              :v-validate="isFTC(extension.handsetID) ? '' : 'required'"
              :readonly="extension.bundleId !== 0"
              ></v-text-field>-->
            </td>
            <td class="currency">{{ rowTotal(extension) | currency }}</td>
          </tr>
          <!--summary-->
          <tr style="border-top: double">
            <td align="center">Total</td>
            <td></td>
            <td></td>
            <td></td>

            <td></td>
            <td class="currency">{{ sumLineTotals | currency }}</td>
          </tr>
          <tr style="border-top: double">
            <td align="center"></td>
            <td></td>
            <td></td>
            <td></td>

            <td>Freight:</td>
            <td class="currency">{{ totalFreight | currency }}</td>
          </tr>
          <tr>
            <td class="currency"></td>
            <td></td>
            <td></td>

            <td></td>
            <td>GST:</td>
            <td class="currency">{{ gst | currency }}</td>
          </tr>
          <tr
            v-if="
              isGrenke ||
              (isGrenke && allFlags.SOG635) ||
              isFinance ||
              financedHardware ||
              financeServices
            "
          >
            <td class="currency"></td>
            <td></td>
            <td></td>

            <td></td>

            <td colspan="2">
              <v-list>
                <v-list-group no-action>
                  <template v-slot:activator>
                    <v-list-tile>
                      <v-list-tile-content>
                        <strong>Finance Details</strong>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>

                  <list-tile
                    v-if="
                      (isGrenke && allFlags.SOG635) ||
                      isFinance ||
                      financedHardware ||
                      financeServices
                    "
                  >
                    <span>ONdesk Finance Amount:</span>
                    <span class="currency">
                      <strong>
                        {{ ONDeskPlanCost | currency }}
                      </strong>
                    </span>
                  </list-tile>
                  <list-tile
                    v-if="
                      (isGrenke && allFlags.SOG635) ||
                      isFinance ||
                      financedHardware ||
                      financeServices
                    "
                  >
                    <span>Additional Hardware Finance:</span>
                    <span class="currency">
                      <strong>
                        {{ additionalHardwareCost | currency }}
                      </strong>
                    </span>
                  </list-tile>
                  <list-tile>
                    <strong>
                      Total {{ isGrenke ? 'Finance' : '' }} Amount
                      {{
                        isGrenke && allFlags.SOG635 ? '(Including GST)' : ''
                      }}:
                    </strong>
                    <span class="currency">
                      <strong>
                        <!-- {{ (sumLineTotals + totalFreight + gst) | currency }} -->
                        {{ totalAmount | currency }}
                      </strong>
                    </span>
                  </list-tile>
                  <list-tile
                    v-if="
                      (allFlags.SOG635 && isGrenke) ||
                      isFinance ||
                      financedHardware ||
                      financeServices
                    "
                    subtitle="* This amount is included in your plan fee payments"
                  >
                    Monthly repayment of plan included hardware:
                    <span class="currency">
                      <strong>
                        {{ ONDeskPlanMonthly | currency }}
                      </strong>
                    </span>
                  </list-tile>
                  <list-tile
                    v-if="
                      (allFlags.SOG635 && isGrenke) ||
                      isFinance ||
                      financedHardware ||
                      financeServices
                    "
                    subtitle="* Charged separately on your monthly Vonex Account"
                  >
                    Monthly repayment of additional financed hardware:
                    <span class="currency">
                      <strong>
                        {{ additionalHardwareMonthLy | currency }}
                      </strong>
                    </span>
                  </list-tile>
                  <list-tile v-if="isGrenke || isFinance">
                    Monthly repayments total:
                    <span class="currency">
                      <strong>
                        {{
                          allFlags.SOG635
                            ? grenkeMonthly
                            : hardware.hardwareOrder.grenkeMonthly | currency
                        }}
                      </strong>
                    </span>
                  </list-tile>
                </v-list-group>
              </v-list>
            </td>
          </tr>
          <template v-else>
            <tr>
              <td colspan="3"></td>
              <td><strong>Finance details</strong></td>
              <td colspan="2"></td>
            </tr>
            <tr>
              <td class="currency"></td>
              <td></td>
              <td></td>

              <td colspan="2">
                <strong>
                  Total {{ isGrenke ? 'Finance' : '' }} Amount
                  {{ isGrenke && allFlags.SOG635 ? '(Including GST)' : '' }}:
                </strong>
              </td>
              <td class="currency">
                <strong>
                  {{ totalAmount | currency }}
                </strong>
              </td>
            </tr>
            <template></template>
            <tr v-if="BackupHandsets.length > 0">
              <td colspan="3"></td>
              <td><strong>Monthly repayments total:</strong></td>
              <td class="currency" colspan="2">
                <strong>${{ backupMonthlyTotal }}</strong>
              </td>
            </tr>
          </template>
        </tbody>
      </table>

      <v-flex sm12 md12 lg12>
        <v-btn name="sbmt" color="primary" @click="save">Save Hardware</v-btn>
      </v-flex>
    </ValidationObserver>

    <message-alert :component="hardware.message"></message-alert>
  </div>
</template>
<script>
import { createNamespacedHelpers, mapGetters } from 'vuex';
import { mapIPVoiceFields } from '@/store/modules/orders';
import {
  mapHardwareMultiRowFields,
  mapInternetMultiRowFields,
} from '@/store/modules/orders';
const {
  mapActions: mapHardwareActions,
  mapMutations: mapHardwareMutations,
  mapState: mapHardwareState,
} = createNamespacedHelpers(`orders/hardware`);
const { mapState: mapOrderState, mapActions: mapOrderActions } =
  createNamespacedHelpers(`orders`);
const { mapState: mapIPVoiceState } = createNamespacedHelpers(`orders/ipVoice`);
const { mapGetters: mapFeatureFlagGetters } =
  createNamespacedHelpers(`orders/featureFlag`);
const { mapActions: mapInternetActions } =
  createNamespacedHelpers(`orders/internet`);
import { httpError } from '../models/httpError';
import {
  QTY_MAX,
  applyCompanionPlan,
  findRowIndex,
  hasInvalidLines,
  isQuantityLocked,
  isValidQuantity,
  lineAmount,
  planCompanionSync,
  saveErrorMessage,
} from '../utils/hardwareLines';
import ListTile from './common/ListTile.vue';
export default {
  components: {
    ListTile,
  },
  data() {
    return {
      delRow: false,
      isEditing: false,
      newSumLineTotal: 0.0,
      newsumQty: 0,
      newFreightTotal: 0.0,
      newGst: 0.0,
      rates: [
        { rate: 3.723, upperBound: 2000 },
        { rate: 3.691, upperBound: 5000 },
        { rate: 3.552, upperBound: 10000 },
        { rate: 3.468, upperBound: 15000 },
        { rate: 3.450, upperBound: 20000 },
        { rate: 3.401, upperBound: 30000 },
        { rate: 3.379, upperBound: 55000 },
        { rate: 3.343, upperBound: 100000 },
      ],
      financedHardware: false,
      qtyChecked: false,
    };
  },
  computed: {
    ...mapGetters('orders', [
      'isQantas',
      'isGrenke',
      'isFinance',
      'isFinancedHardware',
      'financeServices',
      'isQuote',
    ]),
    quantityRule() {
      return `required|integer|between:1,${QTY_MAX}`;
    },
    ...mapIPVoiceFields({ isRental: 'iporder.rental' }),
    ...mapIPVoiceState(['iporder']),
    ...mapHardwareMultiRowFields(['rows', 'handsets', 'nbnHardwares']),
    ...mapHardwareState({ storeRows: 'rows' }),
    ...mapInternetMultiRowFields({ internets: 'rows' }),
    ...mapOrderState({
      hardware: 'hardware',
      isResidential: 'isResidential',
      order: 'rows',
    }),
    ...mapFeatureFlagGetters(['allFlags']),
    bundledHardware() {
      let vm = this;
      let data = vm.filteredAdditionalHardware.map((x) => x.bundleId);
      if (data.includes(NaN)) {
        return false;
      } else return true;
    },
    nonQBRGrenke() {
      let vm = this;
      return (
        vm.order[0].orderType === 3 && vm.rows.length > 0 && !vm.financeServices
      );
    },
    allHandsets() {
      const all_handsets = this.handsets.map((e) => {
        return e;
      });

      return all_handsets;
    },
    validHandsets() {
      return this.handsets
        .filter((x) => (this.isRental ? x.rental == this.isRental : true))
        .filter((x) =>
          this.isGrenke || this.isFinance ? !x.excludeFinanced : true
        )
        .sort(function compare(a, b) {
          if (a.manufacturer && a.manufacturer.description) {
            if (
              a.manufacturer.description.toLowerCase() <
              b.manufacturer.description.toLowerCase()
            )
              return -1;
            if (
              a.manufacturer.description.toLowerCase() >
              b.manufacturer.description.toLowerCase()
            )
              return 1;
            return 0;
          }
        });
    },
    sumQuantity() {
      let quantities = 0;

      this.rows.forEach((x) => {
        if (x.cost > 0) {
          if (!x.freeTypeWithFreight) {
            if (!x.freeTypeNoFreight) quantities = quantities + parseInt(x.quantity);
          } else {
            quantities = quantities + parseInt(x.quantity);
          }
        }
      });
      return quantities;
    },
    totalAmount() {
      let vm = this;
      let total = 0;
      return total + vm.sumLineTotals + vm.totalFreight + vm.gst;
    },
    sumLineTotals() {
      let total = 0;

      if (this.filteredFromIPOrder && this.filteredFromIPOrder.length > 0) {
        this.filteredFromIPOrder.forEach((x) => {
          if (x.lineTotal) total = total + x.lineTotal; //* parseInt(x.quantity);
        });
      }

      if (
        this.filteredAdditionalHardware &&
        this.filteredAdditionalHardware.length > 0
      ) {
        this.filteredAdditionalHardware.forEach((x) => {
          if (x.lineTotal) total = total + x.lineTotal; //* parseInt(x.quantity);
        });
      }

      return total;
    },
    totalFreight() {
      if (this.rows.length > 0) {
        if (this.sumLineTotals == 0.0 || this.sumQuantity === 0) {
          return 0.0;
        }
        return ((this.sumQuantity - 1) * 7.5 + 20.0) * (1 / 1.1);
      } else return 0.0;
    },
    gst() {
      return (this.sumLineTotals + this.totalFreight) / 10;
    },
    align() {
      return this.rows.filter(
        (x) => x.freeTypeWithFreight || x.freeTypeNoFreight
      ).length > 0
        ? 'text-align: left;font-size: 16px;'
        : '';
    },
    filteredFromIPOrder() {
      let _ipOrder = this.rows.filter(
        (x) => x.fromIPOrder === true && x.handsetID !== 10016
      );
      return [..._ipOrder, ...this.BackupHandsets, ...this.fromNbnHardwares];
    },
    filteredAdditionalHardware() {
      let rows = this.rows.filter((x) => x.fromIPOrder == false);
      rows.forEach((x) => {
        if (x.quantity > 1 && x.lineTotal == x.cost)
          x.lineTotal = x.quantity * x.cost;
      });
      return rows;
    },

    additionalHardwareCost() {
      let total = 0;
      if (this.filteredAdditionalHardware.length == 0) return total;
      this.filteredAdditionalHardware.forEach((x) => {
        total += x.cost * x.quantity;
      });
      const freightPercentage = this.getPercentage(
        this.filteredAdditionalHardware.length
      );
      const result = (
        Number(total) +
        Number(this.calcPercent(this.totalFreight, freightPercentage))
      ).toFixed(2);
      return result;
    },

    ONDeskPlanCost() {
      let total = 0;
      if (this.filteredFromIPOrder.length == 0) return total;

      this.filteredFromIPOrder.forEach((x) => {
        total += x.cost * x.quantity;
      });
      const freightPercentage = this.getPercentage(
        this.filteredFromIPOrder.length
      );

      const result = (
        Number(total) +
        Number(this.calcPercent(this.totalFreight, freightPercentage))
      ).toFixed(2);
      return result;
    },
    ONDeskPlanMonthly() {
      const vm = this;
      const rate =
        vm.rates.filter((e) => parseFloat(vm.ONDeskPlanCost) <= e.upperBound)[0]
          .rate / 100.0;
      return vm.ONDeskPlanCost == 0 ? 0 : (vm.ONDeskPlanCost * rate).toFixed(2);
      //Math.round(vm.ONDeskPlanCost * rate).toFixed(2);
    },
    additionalHardwareMonthLy() {
      const vm = this;
      const currentRate = vm.rates
        // .sort((a, b) => a.upperBound - b.upperBound)
        .filter((e) => parseFloat(vm.additionalHardwareCost) <= e.upperBound);
      const rate = currentRate[0].rate / 100.0;
      return (vm.additionalHardwareCost * rate).toFixed(2);
    },
    backupMonthlyTotal() {
      const vm = this;
      let total = 0;
      vm.BackupHandsets.forEach((e) => (total += e.monthlyTotal));
      return total.toFixed(2);
    },
    grenkeMonthly() {
      const vm = this;
      // const rate =
      //   vm.rates.filter(
      //     (e) => vm.sumLineTotals + vm.totalFreight <= e.upperBound
      //   )[0].rate / 100.0;
      // return ((vm.sumLineTotals + vm.totalFreight) * rate).toFixed(2);
      return (
        Number(vm.additionalHardwareMonthLy) + Number(vm.ONDeskPlanMonthly)
      );
    },
    BackupHandsets() {
      const vm = this;
      let databackup = [];
      let result = vm.internets
        .filter((x) => x.dataBackup != null)
        .map((x) => x.dataBackup)
        .reduce((r, a) => {
          r[a.hardwareID] = r[a.hardwareID] || [];
          r[a.hardwareID].push(a);
          return r;
        }, Object.create(null));
      databackup = Object.entries(result).map((e) => {
        return vm.formatHardware(+e[0], e[1].length, e[1]);
      });

      return databackup;
    },
    fromNbnHardwares() {
      const vm = this;
      let modems = [];
      vm.internets
        .filter((x) => x.modemRequired)
        .map((e) => e.contractTerm)
        .forEach((x) => {
          const nbnHardware = vm.nbnHardwares.filter(
            (item) => item.contractLength == x
          )[0];
          if (nbnHardware) {
            modems.push(nbnHardware);
          }
        });

      const transformedList = Object.values(
        modems.reduce((result, item) => {
          const { id, rrp } = item;
          if (!result[id]) {
            result[id] = {
              cost: rrp,
              handsetID: item.hardwareName,
              hardwareID: id,
              lineTotal: 0,
              quantity: 0,
              monthlyTotal: rrp,
              isNbn: true,
            };
          }
          result[id].lineTotal += rrp;
          result[id].quantity++;
          return result;
        }, {})
      );
      return transformedList;
    },
  },
  mounted() {
    let vm = this;
    
    vm.setMessage(new httpError());
    vm.getHandsetsOnOrder();
    vm.getInternet();
    vm.getNBNHardwares().then(() => {
      vm.$emit('loadApplicationHardware', vm.filteredFromIPOrder);
    });
    vm.getHandsets(false).then(() => {
      vm.$emit('loaded');
    });
    vm.getFinancedValue();
  },
  methods: {
    ...mapInternetActions(['getInternet']),
    ...mapOrderActions(['updatedFinanceHardware']),
    ...mapHardwareActions([
      'addHandset',
      'updateHandset',
      'getHandsets',
      'getHardware',
      'setMessage',
      'saveHardware',
      'saveHandsets',
      'getHandsetsOnOrder',
      'updateRowFreight',
      'deleteHardwareRow',
      'getNBNHardwares',
    ]),
    ...mapHardwareMutations(['addRow', 'clearRows']),
    addNewContent(val) {},
    getFinancedValue() {
      let vm = this;
      vm.financedHardware = vm.isFinancedHardware;
    },
    rowTotal(extension) {
      return extension.cost * extension.quantity;
    },
    copyDown: function (column) {
      let vm = this;
      for (var i = 1; i < vm.rows.length; i++) {
        vm.rows[i][column] = vm.rows[0][column];
      }
      return;
    },
    removeRow(index) {
      // Hold the row itself: a reload can move it while the dialog is open.
      const row = this.storeRows[index];
      const main = row && this.handsetById(row.handsetID);
      this.$dialog
        .confirm('Are you sure you want to delete?')
        .then(() => {
          const at = findRowIndex(this.storeRows, row);
          if (at === -1) return;
          return this.deleteRowAt(at).then((deleted) => {
            // a deleted main line takes its companions with it
            if (deleted) this.syncCompanions(main);
          });
        })
        .catch(() => {});
    },
    // The row leaves the screen at once; a failed delete brings it back with
    // the reason. Resolves true when the line is gone.
    deleteRowAt(index) {
      return this.deleteHardwareRow(index).then(
        () => true,
        (err) => {
          this.setMessage({ message: saveErrorMessage(err), httpStatus: 500 });
          return false;
        }
      );
    },
    handsetById(handsetID) {
      return this.handsets.filter((x) => x.handsetID === handsetID)[0];
    },
    // Companions (e.g. the PSU of a handset) follow the total quantity of the
    // main lines that pull them in; no other line changes.
    syncCompanions(mainHandset) {
      if (!mainHandset || !mainHandset.alwaysInclude) return;
      const plan = planCompanionSync(
        this.rows,
        this.handsets,
        mainHandset.relatedHardwareID,
        mainHandset
      );
      applyCompanionPlan(plan, this.rows, {
        addRow: this.addRow,
        deleteRowAt: this.deleteRowAt,
      });
    },
    isFTC(id) {
      let ftcID = this.handsets
        .filter(
          (e) =>
            e.model === 'Free Type Charge' ||
            e.freeTypeWithFreight ||
            e.freeTypeNoFreight
        )
        .map((x) => x.handsetID);
      if (ftcID.some((x) => x === id)) return true;
      else return false;
    },
    onChange: function (data) {
      var handset = this.handsets.filter((x) => x.handsetID === data.handsetID);

      this.updateRowFreight(handset);
      data.cost = this.handsets.filter(
        (e) => e.handsetID == data.handsetID
      )[0].rrpEx;
      data.lineTotal = data.quantity * data.cost;
      // the typed quantity stays; the companion follows it
      this.syncCompanions(handset[0]);
    },
    updateRow: function (index, extension) {
      extension.lineTotal = lineAmount(extension.quantity, extension.cost);

      let handset = this.handsets.filter(
        (x) => x.handsetID === extension.handsetID
      );
      if (handset.length === 0) return;
      this.syncCompanions(handset[0]);
    },
    checkPlan: function (ratePlan) {
      return (
        ratePlan.usageType.includes('VoIP') &&
        ratePlan.dealerSupplied == this.dealerSupplied &&
        ratePlan.mixnMatch !== this.minMonthly &&
        (!this.isResidential ? ratePlan.residential == false : 1 == 1)
      );
    },
    async save() {
      let vm = this;
      vm.qtyChecked = true;
      vm.$refs.observer
        .validate()
        .then(async (result) => {
          if (
            result &&
            !hasInvalidLines(vm.filteredAdditionalHardware, vm.isQuote)
          ) {
            if (vm.isFinance && vm.totalAmount > 0 && vm.totalAmount < 500.0) {
              vm.setMessage({
                message: 'Hardware order must be at least $500',
                httpStatus: 500,
              });
              return;
            }
            try {
              let hw = await vm.saveHardware({ quiet: true });
              let hand = await vm.saveHandsets();
              if (vm.allFlags.SOG3160) {
                vm.updatedFinanceHardware({
                  orderID: vm.order[0].orderID,
                  financedHardware: vm.financedHardware,
                });
              }
              Promise.all([hw, hand]).then(() => {
                vm.getHardware().then(() => {
                  vm.$emit('saved');
                });
              });
            } catch (err) {
              // no reload: the lines stay on screen
              vm.setMessage({
                message: saveErrorMessage(err),
                httpStatus: 500,
              });
            }
          } else {
            vm.setMessage({
              message: 'Unable to save: Check the highlighted fields above',
              httpStatus: 500,
            });
          }
        })
        .catch(function (err) {
          vm.setMessage({ message: err, httpStatus: 500 });
        });
    },
    validRatePlans: function (months) {
      return this.ratePlans
        .filter(this.checkPlan)
        .filter((e) =>
          !this.minMonthly ? e.contractMonths == months : 1 == 1
        ); // && e.dealerSupplied === this.dealerSupplied);
    },
    setText(item) {
      let manufacturer = item.manufacturer ? item.manufacturer.description : '';
      return `${manufacturer} (${item.model})`;
    },
    isCostEditable(extension) {
      return extension.freeTypeWithFreight || extension.freeTypeNoFreight;
    },
    isQuantityLocked,
    showQuantityError(extension) {
      return (
        this.qtyChecked &&
        !isQuantityLocked(extension) &&
        !isValidQuantity(extension.quantity)
      );
    },
    getPercentage(numerator) {
      const denominator = this.rows.length;
      if (denominator > 0) {
        return (numerator / denominator) * 100;
      }
      return 0;
    },

    calcPercent(num, percentage) {
      return num * (percentage / 100);
    },
    formatHardware(hardwareID, qty, data) {
      const vm = this;
      let index = vm.handsets.findIndex((x) => x.handsetID == hardwareID);
      let res = {};

      let monthlyTotal = data.reduce(function (accumulator, currentValue) {
        return accumulator + currentValue.hardwareMonthly;
      }, 0);

      const COST = vm.handsets[index].rrpEx;
      res = {
        cost: COST,
        comment: '',
        handsetID: hardwareID,
        hardwareID: hardwareID,
        lineTotal: COST * qty,
        quantity: qty,
        monthlyTotal: monthlyTotal,
      };
      return res;
    },
  },
};
</script>
<style>
table.table tbody td,
table.table tbody th {
  height: 100%;
}
.currency {
  text-align: right;
}
.display-inline .v-input--selection-controls__input {
  margin-top: -5px !important;
}
.display-inline label {
  font-size: 14px !important;
  color: #212121 !important;
}
.right-div {
  position: absolute;
  right: 24px;
}
.display-inline {
  display: inline-block;
  vertical-align: middle;
}
</style>
